const KEY_REF = "__referrer__"
let location = window.location

export default {
  setReferrer() {
    if (!document.referrer.includes(location.origin)) {
      console.log("store referrer:", document.referrer)
      sessionStorage.setItem(KEY_REF, document.referrer)
    }
  },
  getReferrer() {
    return sessionStorage.getItem(KEY_REF)
  },
  getScale() {
    //@ts-ignore
    return window.__scale__ || 1
  },
  exit() {
    if (location.search) {
      // 通过from参数来退出
      let s = location.search.substring(1)
      if (s) {
        let q: any = {}
        s.split("&").forEach(function (par) {
          let [key, value] = par.split("=")
          q[key] = decodeURIComponent(value)
        })
        if (q.from) {
          location.href = q.from
          return
        }
      }
    }
    location.href = this.getReferrer()
  },
}
